import React, { useEffect, useState } from 'react';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import Loader from 'react-loader-spinner';
import AwsActions from '../../actions/aws_presigned_url';
import PdfPageSelectionModal from "../helpers/PdfPageSelectionModal";
import { createPdfFromSelectedPages } from "../helpers/pdfHelper";
import { PDFDocument } from "pdf-lib";
const DocumentDragAndDrop = ({
  files,
  setFiles,
  operations,
  documentCategories,
  show_inactive,
  fromServiceRequest,
  enablePdfPageSelection = false,
  setFileError,
  sharePdfFile,
}) => {
  const [loading, setLoading]               = useState(false);
  const [local_files, setLocalFiles]        = useState([]);
  const [errorMessage, setErrorMessage]     = useState("");
  const [showPageModal, setShowPageModal] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [pendingFiles, setPendingFiles] = useState([]);
  const [uploadedFilesTemp, setUploadedFilesTemp] = useState([]);

  // useEffect(async () => {
  //   const upload = async () => {
  //   if (!loading || local_files.length === 0) return;

  //   let uploaded_files_temp = [...local_files];

  //   for (let index = 0; index < uploaded_files_temp.length; index++) {
  //     if (uploaded_files_temp[index].file_url === "") {
  //       let s3_response = await get_s3_url(
  //         uploaded_files_temp[index].file_obj
  //       );

  //       uploaded_files_temp[index].file_url = s3_response.public_url;
  //       uploaded_files_temp[index].object_key = s3_response.object_key;
  //     }
  //   }

  //   setFiles(uploaded_files_temp);
  //   setLoading(false);
  // };

  // upload();
  //   // if (loading) {
  //   //   let uploaded_files_temp = [...local_files];

  //   //   for (let index = 0; index < uploaded_files_temp.length; index++) {
  //   //     if (uploaded_files_temp[index].file_url === '') {
  //   //       let s3_response = await get_s3_url(
  //   //         uploaded_files_temp[index].file_obj
  //   //       );
  //   //       uploaded_files_temp[index].file_url = s3_response.public_url;
  //   //       uploaded_files_temp[index].object_key = s3_response.object_key;
  //   //     }
  //   //   }

  //   //   setFiles(uploaded_files_temp);
  //   //   setLoading(false);
  //   // }
  // }, [local_files]);
useEffect(() => {
  const upload = async () => {
    if (!loading || local_files.length === 0) return;

    const uploaded_files_temp = [...local_files];

    for (let index = 0; index < uploaded_files_temp.length; index++) {
      const file = uploaded_files_temp[index];

      if (!file.file_url && file.file_obj) {
        const s3_response = await get_s3_url(file.file_obj);

        uploaded_files_temp[index].file_url =
          s3_response.public_url;

        uploaded_files_temp[index].object_key =
          s3_response.object_key;
      }
    }

    setFiles((previousFiles) => {
      const existingIds = new Set(
        previousFiles.map((file) => file.id)
      );

      const newFiles = uploaded_files_temp.filter(
        (file) => !existingIds.has(file.id)
      );

      return [...previousFiles, ...newFiles];
    });

    setLocalFiles([]);
    setLoading(false);
  };

  upload();
}, [local_files, loading]);

  useEffect(() => {
    window.addEventListener('dragover', (event) => {
      event.preventDefault();
      console.log('Dragged Over');
    });

    window.addEventListener('dragleave', (event) => {
      event.preventDefault();
      console.log('Left Drag Area');
    });

    window.addEventListener('drop', (event) => {
      event.preventDefault();
      console.log('Dropped Image');
      if (event.target.className.includes('upload-area')) {
        onUploadFile(event, true);
      }
    });
  }, []);

  useEffect(() => {
  const addSharedPdf = async () => {
    if (!sharePdfFile?.file) {
      return;
    }

    console.log("Adding shared PDF:", sharePdfFile);
    const baseState = await getBaseStateOnNewDocUpload(
      sharePdfFile.file,
      [sharePdfFile.file]
    );

    baseState.is_shared_with_client = true;
    baseState.shared_from_attachment_id =
      sharePdfFile.originalDocument?.id;

    setLoading(true);

    setLocalFiles((previousFiles) => [
      ...previousFiles,
      baseState,
    ]);
  };

  addSharedPdf();
}, [sharePdfFile]);

  ///////////////////////////////////////////////// Utility Functions /////////////////////////////////////////////////

  const documentIdParser = (document_id) => {
    let tempId = document_id.split('single-doc-')[1];
    if (parseInt(tempId) || parseInt(tempId) === 0) {
      tempId = parseInt(tempId);
    } else {
      tempId = parseInt(tempId.split('new-file-')[1]);
    }

    return tempId;
  };

  const getToday = () => {
    let today = new Date().toJSON().slice(0, 10).replaceAll('-', '/');
    return today;
  };

  const formatDate = (date) => {
    date = new Date(date).toJSON().slice(0, 10).replaceAll('-', '/');
    return date;
  };

  const getUsername = () => {
    let username = JSON.parse(localStorage.getItem('user')).username;
    return username;
  };

  const deep_clone = (current_object) => {
    return JSON.parse(JSON.stringify(current_object));
  };

  const getNewNoteId = (single_doc) => {
    return (single_doc.notes.length + 1) * -1;
  };

  const getNewAttachmentId = (local_temp_files) => {
    let is_duplicate_id = false;
    let new_id = Math.floor(Math.random() * -100) + 1;

    // Check if new_id is applied in files that are currently uploading
    for (let index = 0; index < local_temp_files.length; index++) {
      let single_file = local_temp_files[index];
      if (single_file.id === new_id) {
        is_duplicate_id = true;
      }
    }

    if (is_duplicate_id === false) {
      // if above check is passed for currently uploaded files, then, check for previously uploaded files now
      files.forEach((single_file) => {
        if (single_file.id === new_id) {
          is_duplicate_id = true;
        }
      });
    }

    if (is_duplicate_id) {
      getNewAttachmentId(local_temp_files);
    }

    return new_id;
  };

  ///////////////////////////////////////////////// Utility Functions /////////////////////////////////////////////////

  const renderUploadFileSection = () => {
    let upload_section_html = <></>;

    upload_section_html = (
      <>
        <div className='document-upload' style={{ marginTop: '20px' }}>
          <div
            className='upload-area'
            onClick={(event) => {
              event.preventDefault();
              event.target
                .closest('.document-upload')
                .querySelector('.upload-document-input')
                .click();
            }}
          >
            {/* Drag & Drop area */}
            Click to Select Files
          </div>

          <input
            type='file'
            id='files'
            name='files'
            multiple
            className='upload-document-input'
            onChange={onUploadFile}
            style={{ display: 'none' }}
          />
          {renderUploadedDocs()}
        </div>
      </>
    );

    return upload_section_html;
  };

  const is_fully_valid = (current_file) => {
    let is_valid = true;
    if (fromServiceRequest === true) {
      if (!current_file.type.includes("pdf")) {
        setFileError("Only PDF files are allowed.");
        return false;
      }
      // Check file size (max 10MB)
      if (current_file.size > 10 * 1024 * 1024) {
        setFileError("File size must be less than 10MB.");
        return false;
      }
      setFileError("");
    }
    is_valid = is_valid_type(current_file.type);
    return is_valid;
  };

  const is_valid_type = (current_type) => {
    let is_valid = true;

    operations.allowed_types.some(function (single_item) {
      is_valid = current_type.includes(single_item);
      return is_valid === true;
    });

    return is_valid;
  };

  const getPdfPageCount = async (file) => {
    const bytes = await file.arrayBuffer();
    const pdf = await PDFDocument.load(bytes);
    return pdf.getPageCount();
  };

  const onUploadFile = async (event, is_drag_event) => {
    let files_temp = [];

    if (is_drag_event) {
      files_temp = event.dataTransfer.files;
    } else {
      files_temp = event.target.files;
    }

    let uploaded_files_temp = deep_clone([...files]);

    for (let index = 0; index < files_temp.length; index++) {
      const file = files_temp[index];

      if (is_fully_valid(file)) {
        if (enablePdfPageSelection && file.type === "application/pdf") {
          const pageCount = await getPdfPageCount(file);
          if (pageCount > 1) {
            setSelectedPdf(file);
            setUploadedFilesTemp(uploaded_files_temp); // ✅ Existing files save
            setShowPageModal(true);
            return;
          }
        }
        const base_state = await getBaseStateOnNewDocUpload(
          file,
          files_temp
        );
        uploaded_files_temp.push(base_state);
      }
    }

    setLoading(true);
    setLocalFiles(uploaded_files_temp);
  };
const handlePdfPagesSave = async (selectedPages) => {
  try {
    if (!selectedPages || selectedPages.length === 0) {
      alert("Please select at least one page.");
      return;
    }

    const newPdfFile = await createPdfFromSelectedPages(
      selectedPdf,
      selectedPages
    );

    const base_state = await getBaseStateOnNewDocUpload(
      newPdfFile,
      [newPdfFile]
    );
    base_state.is_shared_with_client = true;
    // Sirf NEW PDF upload hoga
    setLocalFiles([base_state]);

    setLoading(true);

    setShowPageModal(false);
    setSelectedPdf(null);
    setUploadedFilesTemp([]);

  } catch (error) {
    console.error("handlePdfPagesSave Error:", error);
    alert(error.message);
  }
};

  const getBaseStateOnNewDocUpload = async (current_file, local_temp_files) => {
    return {
      id: getNewAttachmentId(local_temp_files),
      file_name: current_file.name,
      file_type: current_file.type,
      file_url: '',
      object_key: '',
      file_obj: current_file,
      name: '',
      in_active: false,
      receipt: false,
      is_shared_with_client: false,
      document_category_id: '',
      notes: [],
    };
  };

  const renderUploadedDocs = () => {
    let uploaded_docs_html = [];

    files.forEach((single_file) => {
      if (single_file._destroy) {
        // If '_destroy' is present and === true in object, then, do not render it
      } else {
        if (single_file.in_active === false) {
          // Always show only active attachments and hide in_active ones
          uploaded_docs_html.push(renderSingleDocSection(single_file));
        }

        if (
          show_inactive === false &&
          single_file.in_active &&
          single_file.id < 0
        ) {
          // If it is inactive but it is new with negative id, then still show it even if checkbox says that show only active ones
          uploaded_docs_html.push(renderSingleDocSection(single_file));
        }

        if (single_file.in_active && show_inactive) {
          // Show inactive ones because the checkbox is checked
          uploaded_docs_html.push(renderSingleDocSection(single_file));
        }
      }
    });

    return uploaded_docs_html;
  };

  const is_pdf = (single_file) => {
    let is_file_pdf = false;

    if (single_file.file_type === undefined) {
      // This is edit form. It does not have file_type key/value
      if (single_file.file_name.toLowerCase().includes('.pdf')) {
        is_file_pdf = true;
      }
    } else if (single_file.file_type.includes('pdf')) {
      is_file_pdf = true;
    }

    return is_file_pdf;
  };

  const is_image = (single_file) => {
    let is_file_image = false;

    if (single_file.file_type === undefined) {
      // This is edit form. It does not have file_type key/value
      if (
        single_file.file_name.includes('.jpg') ||
        single_file.file_name.includes('.jpeg') ||
        single_file.file_name.includes('.png')
      ) {
        is_file_image = true;
      }
    } else if (single_file.file_type.includes('image')) {
      is_file_image = true;
    }

    return is_file_image;
  };

  const renderFileTag = (single_file) => {
    let previewHtml = <></>;

    if (is_pdf(single_file)) {
      previewHtml = (
        <embed
          className='file-upload-tag'
          src={single_file.file_url}
          height='100%'
          width='100%'
        ></embed>
      );
    } else if (is_image(single_file)) {
      previewHtml = (
        <img
          className='file-upload-tag'
          src={single_file.file_url}
          name={single_file.file_name}
        />
      );
    }

    return previewHtml;
  };

  const uploaded_doc_styles = {
    width: '125px',
    height: '125px',
    overflow: 'hidden',
  };

const removeAttachment = (event) => {
  const files_temp = deep_clone([...files]);

  const target_doc_id = documentIdParser(
    event.target.closest('.single-doc').id
  );

  const updatedFiles = files_temp.filter((single_file) => {
    if (target_doc_id === single_file.id) {
      if (target_doc_id < 0) {
        // New attachment
        return false;
      }

      if (target_doc_id > 0) {
        // Existing attachment
        single_file._destroy = true;
      }
    }

    return true;
  });

  setFiles(updatedFiles);

  // IMPORTANT:
  // Remove the same new attachment from local_files
  if (target_doc_id < 0) {
    setLocalFiles((prevFiles) =>
      prevFiles.filter((single_file) => single_file.id !== target_doc_id)
    );
  }

  if (target_doc_id !== undefined && target_doc_id > 0) {
    AwsActions.presignDelete(target_doc_id);
  }
};

const onDocumentCategoryChange = (event, documentId) => {
  const value = event.target.value;

  const uploaded_files_temp = deep_clone([...files]);

  uploaded_files_temp.forEach((file) => {
    if (file.id === documentId) {
      file.document_category_id = value;
    }
  });
  setFiles(uploaded_files_temp);
};

  const renderSingleDocSection = (document) => {
    let singleDocHMTL = <></>;
    singleDocHMTL = (
      <div
        className='uploaded-item single-doc'
        id={`single-doc-${document.id}`}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'end',
          }}
        >
          <a
            href='#'
            onClick={(event) => {
              event.preventDefault();
              removeAttachment(event);
            }}
            className='link-2'
          >
            <span className='text-span-3 close'></span>
          </a>
        </div>
        <div className='uploaded-doc' style={{}}>
          {renderFileTag(document)}
        </div>

        <div className='result-name mb-20'>
          <div>
            <div className='result-input'>
              <div className='flex mb-20'>
                { documentCategories && (
                  <div className='filedset mr-20'>
                    <label className='modal-label'>Document Category</label>
                    <select
                      className='modal-input no-mb w-input'
                      required
                      value={document.document_category_id || ""}
                      onChange={(e) => onDocumentCategoryChange(e, document.id)}
                    >
                      <option value="">Select Category</option>
                      {documentCategories.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.name}
                        </option>
                      ))}
                    </select>
                  </div>      
                )}
                <div className='filedset mr-20'>
                  <label htmlFor='inactive' className='modal-label'>
                    Result Name
                  </label>
                  <input
                    type='text'
                    className='modal-input no-mb w-input'
                    maxLength='256'
                    name='name'
                    required
                    defaultValue={document.name}
                    onChange={onResultChange}
                  />
                </div>
                
                <div className='filedset mr-20'>
                  <label htmlFor='First-Name' className='modal-label'>
                    File Name
                  </label>
                  <input
                    type='text'
                    readOnly
                    className='modal-input no-mb w-input'
                    placeholder={document.file_name}
                  />
                </div>
              </div>
              {!fromServiceRequest &&
                <div className='group-col flex mt-15'>
                  <label htmlFor='in_active' className='modal-label mr-15'>
                    <input
                      type='checkbox'
                      name='in_active'
                      defaultChecked={document.in_active}
                      onChange={onInActiveChange}
                    />{' '}
                    Inactive
                  </label>
                  <label htmlFor='receipt' className='modal-label mr-15'>
                    <input
                      type='checkbox'
                      name='receipt'
                      defaultChecked={document.receipt}
                      onChange={onReceiptChange}
                    />{' '}
                    Receipt
                  </label>
                  {/* <label htmlFor='is_shared_with_client' className='modal-label'>
                    <input
                      type='checkbox'
                      name='is_shared_with_client'
                      defaultChecked={document.is_shared_with_client}
                      onChange={onsharedWithClientChange}
                    />{' '}
                    Shared With Client
                  </label> */}
                </div>
              }
            </div>
          </div>
        </div>

        <hr className='hr-dotted' />

        {renderAddNewNoteSection()}
        {renderNewDocNotesSection(document.id)}
      </div>
    );

    return singleDocHMTL;
  };

  const renderNewDocNotesSection = (document_id) => {
    let notesTableHtml = (
      <table className='table-list'>
        <thead>
          <tr>
            <th>
              <div className='sorting-head'>Note</div>
            </th>
            <th>
              <div className='sorting-head'>Created Date</div>
            </th>

            <th>
              <div className='sorting-head'>Author</div>
            </th>
            <th>&nbsp;</th>
          </tr>
        </thead>
        <tbody>{renderNewDocNotes(document_id)}</tbody>
      </table>
    );

    return notesTableHtml;
  };

  const get_doc_obj = (doc_id) => {
    let files_temp = deep_clone([...files]);
    let doc_obj = {};

    files_temp.forEach((single_file) => {
      if (single_file.id === doc_id) {
        doc_obj = single_file;
      }
    });

    return doc_obj;
  };

  const renderNewDocNotes = (document_id) => {
    let notes_html = [];
    let current_doc = get_doc_obj(document_id);

    current_doc.notes.map((single_note) => {
      if (single_note._destroy === false) {
        notes_html.push(
          <tr style={{ textAlign: 'left' }}>
            <td>{single_note.notes}</td>
            <td className='events-list'>
              {formatDate(single_note.created_at)}
            </td>
            <td className='events-list'>{single_note.user}</td>
            <td>
              <a
                href='#'
                className='btn btn-delete'
                onClick={(event) => {
                  event.preventDefault();
                  removeNote(event, current_doc);
                }}
                id={`single-note-${single_note.id}`}
              >
                Delete
              </a>
            </td>
          </tr>
        );
      }
    });

    return notes_html;
  };

  const removeNote = (event, current_doc) => {
    let files_temp = deep_clone([...files]);
    let target_note_id = parseInt(event.target.id.split('single-note-')[1]);

    files_temp.map((single_file, index) => {
      if (current_doc.id === single_file.id) {
        single_file.notes.map((single_note, inner_index) => {
          if (parseInt(target_note_id) === single_note.id) {
            if (target_note_id < 0) {
              // That is a New Note
              files_temp[index].notes.splice(inner_index, 1);
            } else if (target_note_id > 0) {
              // That is an Old Note. We are most probably editing Document Collection
              files_temp[index].notes[inner_index]._destroy = true;
            }
          }
        });
      }
    });

    setFiles(files_temp);
  };

  const renderAddNewNoteSection = () => {
    let newNote = <></>;

    newNote = (
      <>
        <div className='add-note-heading'>
          <h4>Add Note</h4>
        </div>
        <div className='new-notes-container flex space-between align-center'>
          <textarea name='new_note_txt' cols='65' rows='2'></textarea>
          <input
            onClick={onNewNoteSave}
            type='button'
            value='Save'
            className='btn add-btn new-note-add-btn'
          />
        </div>
      </>
    );

    return newNote;
  };

  const onNewNoteSave = (event) => {
    event.preventDefault();
    let notes_val = event.target.parentElement.querySelector('textarea').value;

    if (notes_val === '') {
      // Do Nothing for empty values
    } else {
      let uploaded_files_temp = deep_clone([...files]);
      let current_doc_id = documentIdParser(
        event.target.closest('.single-doc').id
      );

      uploaded_files_temp.forEach((single_doc, index) => {
        if (single_doc.id === current_doc_id) {
          // Save notes in this document
          let noteData = {
            id: getNewNoteId(single_doc),
            document_id: current_doc_id,
            notes: notes_val,
            created_at: getToday(),
            user: getUsername(),
            _destroy: false,
          };

          if (uploaded_files_temp[index].notes.length) {
            uploaded_files_temp[index].notes = deep_clone(
              uploaded_files_temp[index].notes
            );
            uploaded_files_temp[index].notes.push(noteData);
          } else {
            uploaded_files_temp[index].notes = [];
            uploaded_files_temp[index].notes.push(noteData);
          }
        }
      });

      event.target.parentElement.querySelector('textarea').value = '';
      setFiles(uploaded_files_temp);
    }
  };

  const onResultChange = (event) => {
    let result_txt_box = event.target.value;
    let current_doc_id = documentIdParser(
      event.target.closest('.single-doc').id
    );
    let uploaded_files_temp = deep_clone([...files]);

    uploaded_files_temp.forEach((single_doc, index) => {
      if (single_doc.id === current_doc_id) {
        // Save result in this document
        uploaded_files_temp[index].name = result_txt_box;
      }
    });

    setFiles(uploaded_files_temp);
  };

  const onInActiveChange = (event) => {
    let in_active_inp = event.target.checked;
    let current_doc_id = documentIdParser(
      event.target.closest('.single-doc').id
    );
    let uploaded_files_temp = deep_clone([...files]);

    uploaded_files_temp.forEach((single_doc, index) => {
      if (single_doc.id === current_doc_id) {
        // Save in-active in this document
        uploaded_files_temp[index].in_active = in_active_inp;
      }
    });

    setFiles(uploaded_files_temp);
  };

  const onReceiptChange = (event) => {
    let receipt_txt_box = event.target.checked;
    let current_doc_id = documentIdParser(
      event.target.closest('.single-doc').id
    );
    let uploaded_files_temp = deep_clone([...files]);

    uploaded_files_temp.forEach((single_doc, index) => {
      if (single_doc.id === current_doc_id) {
        // Save receipt in this document
        uploaded_files_temp[index].receipt = receipt_txt_box;
      }
    });

    setFiles(uploaded_files_temp);
  };

  const onsharedWithClientChange = (event) => {
    let is_shared = event.target.checked;
    let current_doc_id = documentIdParser(
      event.target.closest('.single-doc').id
    );
    let uploaded_files_temp = deep_clone([...files]);

    uploaded_files_temp.forEach((single_doc, index) => {
      if (single_doc.id === current_doc_id) {
        // Save shared in this document
        uploaded_files_temp[index].is_shared_with_client = is_shared;
      }
    });
    setFiles(uploaded_files_temp);
  };

  const get_s3_url = async (current_file) => {
    const response = await AwsActions.getPresignedUrl({
      filename: current_file.name,
      path: process.env.REACT_APP_AWS_DIR_NAME,
    });
    await AwsActions.uploadToS3(response.data.presigned_url, current_file);
    return response.data;
  };

  const renderPage = () => {
    if (loading) {
      return (
        <>
          <div style={{ marginTop: '20px' }}>
            <Loader
              type='Circles'
              color='#00BFFF'
              height={150}
              width={150}
              timeout={20000} //3 secs
            />
          </div>
        </>
      );
    } else {
      return <>{renderUploadFileSection()}</>;
    }
  };

  return <>
    {renderPage()}
    <PdfPageSelectionModal
      open={showPageModal}
      file={selectedPdf}
      onClose={()=>{
          setShowPageModal(false);
          setSelectedPdf(null);
      }}
      onSave={handlePdfPagesSave}
    />
  </>;
};

export default DocumentDragAndDrop;

DocumentDragAndDrop.defaultProps = {
  show_inactive: true,
};
